export default {
  buttons: {
    signup: 'Opret konto',
    login: 'Log ind',
  },
};
